import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10.75 11.75H8.625a4.875 4.875 0 0 0-4.875 4.875c0 .898.728 1.625 1.625 1.625H8.75m4-2.5 2.25 2.5 4.25-4.5m-6-8.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"
	})]
});
const ForwardRef = forwardRef(SvgUserCheck);
export { ForwardRef as ReactComponent };
